export class DragDropLocation {
    oldParentId!: string;
    newParentId!: string;
    locationId!:string
  }